// extracted by mini-css-extract-plugin
export var alignLeft = "D_rd d_fp d_bG d_dv";
export var alignCenter = "D_bP d_fq d_bD d_dw";
export var alignRight = "D_rf d_fr d_bH d_dx";
export var comparisonComponentContentEqual = "D_h9 d_h9 d_b1 d_w d_bz d_bF d_bJ d_w";
export var comparisonComponentEqual = "D_jc d_jc d_w d_y d_cX";
export var positioner = "D_vN";
export var wrapper = "D_ry d_c8";